import { render, staticRenderFns } from "./TranscriptQueueMTA.vue?vue&type=template&id=4182fa3b&"
import script from "./TranscriptQueueMTA.vue?vue&type=script&lang=js&"
export * from "./TranscriptQueueMTA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports